import { IStoreRootState } from "@/store/interface";
import { ModuleTree } from "vuex";
import { PAYMENT_REQUIREMENTS_INCOMING_MODULE_NAME } from "./incoming/constants";
import { PAYMENT_REQUIREMENTS_OUTGOING_MODULE_NAME } from "./outgoing/constants";
import paymentRequirementsIncoming from './incoming';
import paymentRequirementsOutgoing from './outgoing';
import paymentRequirementsHistory from './history';
import { PAYMENT_REQUIREMENTS_HISTORY_MODULE_NAME } from "./history/constants";

export default <ModuleTree<IStoreRootState>> {
	[PAYMENT_REQUIREMENTS_INCOMING_MODULE_NAME]: paymentRequirementsIncoming,
	[PAYMENT_REQUIREMENTS_OUTGOING_MODULE_NAME]: paymentRequirementsOutgoing,
	[PAYMENT_REQUIREMENTS_HISTORY_MODULE_NAME]: paymentRequirementsHistory
}